"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ala": {
    "b8d4d549": [{
      "hkey": "c508dee8",
      "slug": "ala",
      "name": "Ala",
      "primary": true,
      "skipSearch": false
    }],
    "marani": [{
      "hkey": "c508dee8",
      "slug": "ala",
      "name": "Ala",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d74f47ab": [{
      "hkey": "ca51122e",
      "slug": "ronchi",
      "name": "Ronchi",
      "primary": true,
      "skipSearch": false
    }],
    "a7af85e9": [{
      "hkey": "c508dee8",
      "slug": "ala",
      "name": "Ala",
      "primary": true,
      "skipSearch": false
    }],
    "ronchi-di-ala": [{
      "hkey": "ca51122e",
      "slug": "ronchi",
      "name": "Ronchi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "sega": [{
      "hkey": "c508dee8",
      "slug": "ala",
      "name": "Ala",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;